const state = () => ({
  status: 0, // 200 404 408
  type: "live",
  corpId: 0,
  channelInfo: {},
  menuList: [],
  playerInfo: { playUrl: "", saveUrl: "", cameraId: "" },
  wechatInfo: {},
  userInfo: {},
  uuid: '',
  playerAddress: null,
  globalSetting: {},
  isDMSLinked: false,
  drainage: {},
});
export default state;
